import { FieldError } from 'react-hook-form';
import { TextField, TextFieldProps, useTheme } from '@mui/material';

type TextFieldWithHelperSpaceProps = TextFieldProps & {
    fieldError?: FieldError;
};

const messageEmptyPlaceholder = '\u00A0';

export const TextFieldWithHelperSpace = ({
    fieldError,
    ...props
}: TextFieldWithHelperSpaceProps) => {
    const theme = useTheme();
    return (
        <TextField
            {...props}
            error={!!fieldError}
            helperText={fieldError?.message || messageEmptyPlaceholder}
            aria-invalid={!!fieldError}
            fullWidth
            sx={{
                '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                        borderColor: theme.palette.customColors.purple,
                    },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.customColors.purple,
                },
            }}
        />
    );
};
